var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "reject-grey-a",
    d: "M5,15.8333333 C5,16.75 5.75,17.5 6.66666667,17.5 L13.3333333,17.5 C14.25,17.5 15,16.75 15,15.8333333 L15,5.83333333 L5,5.83333333 L5,15.8333333 Z M7.05,9.9 L8.225,8.725 L10,10.4916667 L11.7666667,8.725 L12.9416667,9.9 L11.175,11.6666667 L12.9416667,13.4333333 L11.7666667,14.6083333 L10,12.8416667 L8.23333333,14.6083333 L7.05833333,13.4333333 L8.825,11.6666667 L7.05,9.9 Z M12.9166667,3.33333333 L12.0833333,2.5 L7.91666667,2.5 L7.08333333,3.33333333 L4.16666667,3.33333333 L4.16666667,5 L15.8333333,5 L15.8333333,3.33333333 L12.9166667,3.33333333 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "reject-grey-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reject-grey-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#B2B2B2",
    mask: "url(#reject-grey-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2,
    height: 20.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectGrey);
export default __webpack_public_path__ + "static/media/reject-grey.7e659510.svg";
export { ForwardRef as ReactComponent };